module.exports = __webpack_public_path__ + "img/Angiogenesis-CRC_GSE206552.ae82b6b1.png";